export const SET_TOUCHED = 'SET_TOUCHED';
export const setTouched = value => ({
  type: SET_TOUCHED,
  value
});